module.exports = __webpack_public_path__ + "assets/img/scan-report-1.85cbd529.png";